module.exports = __webpack_public_path__ + "static/baby-throwing-money-d1288d8528191eb3e4d0db2ba48406b9.webp";